import {Filter} from './filter';

export const FILTERS_CONFIG = {
  gas: {
    years: [],
    marketHubs: [
      new Filter('NCG', true, 0),
      new Filter('GPL', true, 1)
    ],
    periodDivisions: [
      new Filter('CAL', true, 0),
      new Filter('S', false, 1),
      new Filter('W', false, 2),
      new Filter('Q1', false, 3),
      new Filter('Q4', false, 4),
    ]
  },
  electricity: {
    years: [],
    marketHubs: [
      new Filter('EEX', true, 0)
    ],
    periodDivisions: [
      new Filter('CAL', true, 0),
      new Filter('Q1', false, 1),
      new Filter('Q4', false, 2),
    ],
    flavors: [
      new Filter('Base', true, 0),
      new Filter('Peak', true, 1),
      new Filter('Offpeak', false, 2)
    ]
  }
};

